import { Button, Col, Input, Row } from 'antd';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  UserPlanDataContext,
} from '../../../../../../../context';
import styles from './styles.module.scss';
import { errorHandling } from '../../../../../../../utils/helper';
import errorColumnMap from '../../../../../../../utils/error-message-mapping';

interface TaskProps {
  plan_id: string;
  id: number | string;
  description: string;
  duration: number;
  spend_time: number;
  status: any;
}

const Task: React.FC<TaskProps> = ({
  plan_id,
  id,
  description,
  duration,
  spend_time,
  status,
}: TaskProps) => {
  const { employeeId } = useParams();
  const [inputSpendTime, setInputSpendTime] = useState<number>();
  const { userPlanData, setUserPlanData } = useContext(UserPlanDataContext);
  const [spendTimeEditMode, setSpendTimeEditMode] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const isAdmin = useContext(IsAdminContext);
  const makeRequest = (reqBody: any) => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/plans';
      reqBody['profile_id'] = employeeId;
    } else {
      url = '/api/v1/profile/plans';
    }
    axiosInstance
      .post(url, reqBody)
      .then((response: any) => {
        const filteredPlanData = response.data.plans.filter((plan: any) => {
          return plan.status.id === 1;
        });
        setInputSpendTime(undefined);
        setUserPlanData(filteredPlanData);
        setErrorMessage({});
      })
      .catch((error: any) => {
        console.log(reqBody);
        errorHandling(error, setErrorMessage);
        setInputSpendTime(undefined);
      });
  };

  const handleChange = (e: any) => {
    setInputSpendTime(e.target.value);
  };

  const updateTaskStatus = () => {
    const reqBody: any = {};
    reqBody['plan_id'] = plan_id;
    reqBody['task'] = [];
    const taskBody: any = {
      task_id: id,
      status: status.id === 1 ? 2 : 1,
    };
    reqBody['task'].push(taskBody);
    makeRequest(reqBody);
  };

  const updateSpendTime = () => {
    setErrorMessage({});
    if (
      inputSpendTime &&
      inputSpendTime !== spend_time &&
      Number(inputSpendTime)
    ) {
      const reqBody: any = {};
      reqBody['plan_id'] = plan_id;
      reqBody['task'] = [];
      const taskBody: any = {
        task_id: id,
        spend_time: Number(spend_time) + Number(inputSpendTime),
      };
      reqBody['task'].push(taskBody);
      makeRequest(reqBody);
    }
  };
  const deleteTask = () => {
    const reqBody: any = {};
    reqBody['plan_id'] = plan_id;
    reqBody['task'] = [];
    const taskBody: any = {
      task_id: id,
      status: 3,
    };
    reqBody['task'].push(taskBody);
    makeRequest(reqBody);
  };
  return (
    <>
      <Row className={styles['task-row']}>
        <Col span={13} className={styles.col}>
          <img
            src="/check_circle.png"
            style={{
              float: 'left',
              marginRight: '10px',
              marginTop: '10px',
              cursor: 'pointer',
              backgroundColor: status.id === 1 ? 'green' : 'transparent',
              borderRadius: '50px',
            }}
            onClick={updateTaskStatus}
          />

          <p
            className={styles['task-value']}
            style={{
              textDecoration: status.id === 1 ? 'line-through' : 'none',
            }}
          >
            {description}
          </p>
        </Col>
        <Col span={10} className={styles.col}>
          <Row>
            <Col span={24}>
              <p className={styles['task-value']}>
                <span
                  style={{
                    width: '150px',
                    display: 'inline-block',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    setSpendTimeEditMode(true);
                  }}
                >
                  {duration + ' Hrs'}
                  <span style={{ color: '#9e9e9e' }}>
                    {' (' + spend_time + ' Hrs)'}{' '}
                  </span>
                </span>
                <span>
                  <Input
                    type="text"
                    // defaultValue={spend_time}
                    value={inputSpendTime}
                    placeholder="Log(hr)"
                    onChange={handleChange}
                    onClick={(e) => {
                      setSpendTimeEditMode(true);
                    }}
                    style={{
                      width: '100px',
                      height: '43px',
                      marginLeft: '10px',
                      marginRight: '10px',
                      background: '#59606A',
                      border: 'none',
                      color: 'white',
                      borderBottom:
                        'spend_time' in errorMessage ? '1px solid red' : 'none',
                    }}
                  />
                  <img
                    src="/check_circle.png"
                    onClick={(e) => {
                      updateSpendTime();
                    }}
                    style={{
                      cursor: 'pointer',
                      marginLeft: '5px',
                      marginRight: '5px',
                      backgroundColor: 'green',
                      borderRadius: '50px',
                      visibility: spendTimeEditMode ? 'visible' : 'hidden',
                    }}
                  />
                  <img
                    src="/cancel.png"
                    onClick={(e) => {
                      setSpendTimeEditMode(false);
                      setInputSpendTime(undefined);
                    }}
                    style={{
                      cursor: 'pointer',
                      marginLeft: '5px',
                      marginRight: '5px',
                      visibility: spendTimeEditMode ? 'visible' : 'hidden',
                    }}
                  />
                </span>
              </p>
              {'spend_time' in errorMessage ? (
                <Row>
                  <p style={{ color: 'red' }}>
                    {'spend_time' in errorMessage
                      ? errorColumnMap['spend_time'] +
                        ' : ' +
                        errorMessage['spend_time']
                      : ''}
                  </p>
                </Row>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={1}>
          <p className={styles['task-value']}>
            <img
              src="/delete_blue.png"
              style={{
                float: 'right',
                marginRight: '10px',
                cursor: 'pointer',
                marginTop: '13px',
              }}
              onClick={deleteTask}
            />
          </p>
        </Col>
      </Row>
    </>
  );
};

export default Task;
